"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CategoryMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _nuiIntl = require("@concur/nui-intl");

var _nuiWidgets = require("@concur/nui-widgets");

var _utils = require("../utils");

var _analytics = require("../constants/analytics");

var ListingsActions = _interopRequireWildcard(require("../listings/listingsModule"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var defaultCategory = {
  slug: 'all',
  code: 'ALL_APPS',
  description: 'All Apps'
};
var ACTION_POP = 'POP';

var CategoryMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CategoryMenu, _React$Component);

  function CategoryMenu(props) {
    var _this;

    _classCallCheck(this, CategoryMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoryMenu).call(this, props));
    _this.handleLinkClick = _this.handleLinkClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CategoryMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.backListenerCallback = function (location) {
        if (location.action === ACTION_POP) {
          var pathname = _this2.props.location.pathname;
          var slug = pathname.substr(pathname.lastIndexOf('/') + 1); // not logged in uses app-center, logged in uses appcenter

          if (slug === 'app-center' || slug === 'appcenter') {
            slug = 'all';
          }

          _this2.props.categories.map(function (category) {
            if (category.slug === slug) {
              _this2.props.setCategory(category);

              return;
            }

            category.subcategories.map(function (subcategory) {
              if (subcategory.slug === slug) {
                _this2.props.setCategory(subcategory);
              }
            });
          });
        }
      };

      this.backListener = _reactRouter.browserHistory.listen(this.backListenerCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Unbind listener
      this.backListener();
    }
  }, {
    key: "handleLinkClick",
    value: function handleLinkClick(category) {
      var _this$props = this.props,
          router = _this$props.router,
          location = _this$props.location,
          setAndFilterByCategory = _this$props.setAndFilterByCategory,
          trackCategoryLinkClick = _this$props.trackCategoryLinkClick,
          companyUUID = _this$props.companyUUID;
      var pathname = (0, _utils.getAppCenterPathName)(location.pathname);
      var categoryRoute = "".concat(pathname, "/category/").concat(category.slug);
      var context = router.location.pathname === pathname ? _analytics.CONTEXTS.HOME : _analytics.CONTEXTS.LISTING_DETAILS;
      setAndFilterByCategory(category);
      router.push(categoryRoute); // track clicks

      if (typeof caLogger !== 'undefined') {
        caLogger.track(_analytics.EVENTS.CLICK, {
          context: context,
          type: _analytics.TYPES.LINK,
          value: _analytics.VALUES.CATEGORY,
          category: category.description,
          domain: window.location.hostname
        });
      }

      trackCategoryLinkClick({
        elementPath: [_analytics.categoryDropdown, category.slug],
        dimensions: {
          category: category.slug,
          companyUUID: companyUUID
        }
      });
    }
  }, {
    key: "renderCategories",
    value: function renderCategories() {
      var _this3 = this;

      var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var isChildren = arguments.length > 1 ? arguments[1] : undefined;
      var _this$props$category = this.props.category,
          currentCategory = _this$props$category === void 0 ? defaultCategory : _this$props$category;
      return categories.reduce(function (items, category) {
        items.push(_react.default.createElement(_nuiWidgets.MenuItem, {
          key: category.code,
          eventKey: category,
          active: currentCategory.code === category.code,
          className: isChildren && 'subcategories'
        }, category.description));

        if (category.subcategories) {
          return items.concat(_this3.renderCategories(category.subcategories, true));
        }

        return items;
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          formatter = _this$props2.formatter,
          categories = _this$props2.categories,
          category = _this$props2.category,
          display = _this$props2.display;
      var label = "".concat(formatter.formattedMessage({
        id: 'Category'
      }), ":");
      return display ? _react.default.createElement(_nuiWidgets.ButtonToolbar, {
        muted: true,
        style: {
          paddingTop: '4px',
          paddingBottom: '6px'
        }
      }, _react.default.createElement(_nuiWidgets.ButtonDropdown, {
        id: "categoryDropdown",
        type: "link",
        textLabel: label,
        title: category === undefined ? categories[0].description : category.description,
        onSelect: this.handleLinkClick
      }, this.renderCategories(categories))) : _react.default.createElement("br", null);
    }
  }]);

  return CategoryMenu;
}(_react.default.Component);

exports.CategoryMenu = CategoryMenu;
CategoryMenu.propTypes = {
  setAndFilterByCategory: _propTypes.default.func.isRequired,
  categories: _propTypes.default.arrayOf(_propTypes.default.object),
  router: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  display: _propTypes.default.bool,
  category: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  trackCategoryLinkClick: _propTypes.default.func,
  companyUUID: _propTypes.default.string,
  listingName: _propTypes.default.string
};

function mapStateToProps(state) {
  return {};
}

var mapDispatchToProps = {
  setCategory: ListingsActions.setCategory
};

var _default = (0, _nuiIntl.withFormatter)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CategoryMenu)));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/CategoryMenu.js
// module id = 244
// module chunks = 0